<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ (data.sourceId == null ? data.sysText.addNewTemplate_header : data.sysText.duplicateTemplate_header) }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button
      type="button"
      class="button-reset"
      (click)="cancel()"
      [attr.aria-label]="data.sysText.cancel"
      [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>
<mat-dialog-content>
  <app-input-field
    [control]="form.controls.templateName"
    [icon]="'email'"
    [label]="data.sysText.templateName"
    [inputType]="'string'"
    [hint]="(data.sourceId != null ? data.sysText.duplicateMessage.replace('@[sourceName]', data.sourceName) : null)">
  </app-input-field>
  @if (data.sourceId == null) {
    <app-select-field
      [control]="this.form.controls.emailType"
      [label]="data.sysText.emailType"
      [options]="data.addNewTemplateDialog.emailTypes"
      [icon]="'subject'"
      [shouldCapitalize]="false">
    </app-select-field>
  }
  @if (data.sourceId != null) {
    <app-input-field
      [control]="form.controls.sourceType"
      [icon]="'subject'"
      [label]="data.sysText.emailType"
      [inputType]="'string'"
      [hint]="data.sysText.duplicateMessageEmailType"
      [isDisabled]="true">
    </app-input-field>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{ data.sysText.add }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

